module.exports = __webpack_public_path__ + "static/img/联想 拯救者Y7000P.bd96b507.png";